/**
 * Raw axial hex distance from origin (0, 0). Dependency-free so both the
 * settlement substrate (HEX-93) and the frontier-risk layer can share it
 * without an import cycle — `frontierSettlement` needs origin distance for its
 * keep-out, and `frontierRisk.safeZoneDistance` builds on it for the
 * settlement-eased metric.
 */
export function originDistance(q: number, r: number): number {
  return (Math.abs(q) + Math.abs(r) + Math.abs(q + r)) / 2;
}
